import {
  DocumentNode,
  OperationVariables,
  TypedDocumentNode,
} from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { ApiName } from 'types/apiName';

export const createUseApiQuery = (apiName: ApiName) => {
  return function useApiQuery<
    TData = unknown,
    TVars extends OperationVariables = OperationVariables,
  >(
    query: DocumentNode | TypedDocumentNode<TData, TVars>,
    options?: useQuery.Options<TData, TVars>,
  ): useQuery.ResultForOptions<TData, TVars, useQuery.Options<TData, TVars>> {
    const queryOptions = options
      ? {
          ...options,
          context: {
            ...(options.context ?? {}),
            apiName,
          },
        }
      : { context: { apiName } };

    return useQuery(
      query,
      queryOptions as useQuery.Options<TData, TVars>,
    ) as useQuery.ResultForOptions<
      TData,
      TVars,
      useQuery.Options<TData, TVars>
    >;
  };
};

export const useApiQuery = createUseApiQuery;
